// @flow strict

import styled from 'styled-components';

export const RawStyledTabGroupTab = styled.li`
  flex: ${props => (props.$isEqualWidth ? '1' : undefined)};
`;

export const StyledTabGroupTab = RawStyledTabGroupTab;
